module.exports = (__webpack_require__(0))(20);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/models/FolderModel.js from dll-reference girder_lib
// module id = 15
// module chunks = 0